/**
 * FAQ accordion: height animation (WAAPI), pill hash sync.
 */
(function () {
  var REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)');
  var OPEN_MS = 550;
  var CLOSE_MS = 1000;
  var EASE = 'cubic-bezier(0.33, 1, 0.68, 1)';

  function prefersReducedMotion() {
    return REDUCED_MOTION.matches;
  }

  function getPanelOuter(details) {
    return details.querySelector('.faq-accordion__panel-outer');
  }

  function readPanelHeight(outer) {
    return Math.round(outer.getBoundingClientRect().height);
  }

  function cancelAnimation(details) {
    var state = details._faqAnim;
    if (!state) return;

    if (state.animation) {
      state.animation.cancel();
    }
    if (state.fallbackId) {
      clearTimeout(state.fallbackId);
    }

    details._faqAnim = null;
    details.classList.remove('faq-accordion__item--animating', 'faq-accordion__item--closing');
  }

  function settleOpenPanel(outer) {
    outer.style.overflow = '';
    outer.style.height = readPanelHeight(outer) + 'px';
  }

  function settleClosedPanel(outer) {
    outer.style.overflow = 'hidden';
    outer.style.height = '0px';
  }

  function runHeightAnimation(details, outer, fromPx, toPx, durationMs, onFinish) {
    outer.style.overflow = 'hidden';
    outer.style.height = fromPx + 'px';
    void outer.offsetHeight;

    if (fromPx === toPx || prefersReducedMotion()) {
      outer.style.height = toPx + 'px';
      onFinish();
      return;
    }

    var animation = outer.animate(
      [{ height: fromPx + 'px' }, { height: toPx + 'px' }],
      { duration: durationMs, easing: EASE, fill: 'forwards' }
    );

    function finish() {
      var state = details._faqAnim;
      if (!state || state.animation !== animation) return;

      clearTimeout(state.fallbackId);
      animation.cancel();
      outer.style.height = toPx + 'px';
      onFinish();
    }

    animation.addEventListener('finish', finish);
    animation.addEventListener('cancel', function () {
      if (details._faqAnim && details._faqAnim.animation === animation) {
        details._faqAnim = null;
      }
    });

    details._faqAnim = {
      outer: outer,
      animation: animation,
      fallbackId: setTimeout(finish, durationMs + 200),
    };
  }

  function runPanelTransition(details, shouldOpen) {
    var outer = getPanelOuter(details);
    if (!outer) return;

    cancelAnimation(details);

    if (prefersReducedMotion()) {
      details.open = shouldOpen;
      if (shouldOpen) {
        details.classList.remove('faq-accordion__item--animating', 'faq-accordion__item--closing');
        settleOpenPanel(outer);
      } else {
        details.open = false;
        settleClosedPanel(outer);
      }
      return;
    }

    details.classList.add('faq-accordion__item--animating');
    if (!shouldOpen) {
      details.classList.add('faq-accordion__item--closing');
    }

    if (shouldOpen) {
      details.open = true;
      var openTo = outer.scrollHeight;

      runHeightAnimation(details, outer, 0, openTo, OPEN_MS, function () {
        cancelAnimation(details);
        settleOpenPanel(outer);
      });
      return;
    }

    if (!details.open) return;

    var closeFrom = readPanelHeight(outer);
    if (closeFrom < 1) {
      closeFrom = outer.scrollHeight;
    }

    runHeightAnimation(details, outer, closeFrom, 0, CLOSE_MS, function () {
      cancelAnimation(details);
      details.open = false;
      settleClosedPanel(outer);
    });
  }

  function shouldOpenOnClick(details) {
    if (details.classList.contains('faq-accordion__item--closing')) {
      return true;
    }
    if (
      details.classList.contains('faq-accordion__item--animating') &&
      details.open
    ) {
      return false;
    }
    return !details.open;
  }

  function initAccordionItems(root) {
    root.classList.add('faq-accordion--js');

    root.querySelectorAll('.faq-accordion__item').forEach(function (details) {
      if (details.dataset.faqAccordionInit) return;
      details.dataset.faqAccordionInit = 'true';

      var summary = details.querySelector('.faq-accordion__summary');
      var outer = getPanelOuter(details);
      if (!summary || !outer) return;

      if (details.open) {
        settleOpenPanel(outer);
      } else {
        settleClosedPanel(outer);
      }

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        runPanelTransition(details, shouldOpenOnClick(details));
      });
    });
  }

  function syncPills() {
    var hash = (window.location.hash || '').replace(/^#/, '');
    document.querySelectorAll('.faq-accordion').forEach(function (root) {
      if (!root.querySelector('.faq-accordion__pill')) return;
      root.querySelectorAll('.faq-accordion__pill').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        var id = href.charAt(0) === '#' ? href.slice(1) : href;
        var on = Boolean(id && id === hash);
        a.classList.toggle('faq-accordion__pill--active', on);
        if (on) {
          a.setAttribute('aria-current', 'true');
        } else {
          a.removeAttribute('aria-current');
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.faq-accordion').forEach(initAccordionItems);
    syncPills();
  }

  window.addEventListener('hashchange', syncPills);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
